import { Injectable, inject } from '@angular/core';
import {filter} from 'rxjs/operators';
import {NavigationEnd, NavigationStart, Router} from '@angular/router';
import {environment} from '../../../environments/environment';
import {SubscribeService} from './subscribe.service';

@Injectable({
    providedIn: 'root',
})
export class RouterHistoryService {
    private router = inject(Router);
    private _subscribeService = inject(SubscribeService);

    private urls: string[] = [window.location.pathname];

    constructor() {
        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(({ urlAfterRedirects }: NavigationEnd) => {
                this.urls = [...this.urls, urlAfterRedirects];
            });

        //Suppression des requetes en cas de changement de page
        if (environment.annulationRequetesRouteChange) {
            this.router.events
                .pipe(filter(event => event instanceof NavigationStart))
                .subscribe(() => {
                    this._subscribeService.closeAllRef(true);
                });
        }
    }

    public reset(){
        this.urls = [];
    }
    public navPrevious() {
        this.router.navigate([this.getPreviousUrl()]);
    }

    public getHistory(): string[] {
        return this.urls;
    }

    public getActualUrl(): string {
        return this.urls[this.urls.length - 1] || '/';
    }

    public getPreviousUrl(): string {
        return this.urls[this.urls.length - 2] || '/';
    }

    public navTo(patch: string = '/') {
        this.router.navigate([patch]);
    }
}
